module.exports = __webpack_public_path__ + "img/add-photo-third-icon.babd9899.svg";